import React, { Fragment } from "react";
import { Card, Col, Button } from 'react-bootstrap';
import '../../../styles/diario.scss'

const Local = (props) => {

    return (
        <Fragment>
            <Col>
                <Card className="card-list">
                    <Card.Header><h5>{props.loc.nome}</h5></Card.Header>
                    <Card.Body>
                        <h6>{props.loc.secretaria}</h6>
                        <p>Endereço: <strong>{props.loc.endereco}</strong></p>
                        <p>Horário de Funcionamento: <strong>{props.loc.horarios}</strong></p>
                        <p>Telefone: <strong>{props.loc.telefone}</strong></p>
                        {props.loc.telefonePlantao ? <p>Telefone do Plantão: {props.loc.telefonePlantao}</p> : null}
                        {props.loc.email ? <p>E-mail: {props.loc.email}</p> : null}
                        {props.loc.secretaria === "Secretaria Municipal de Educação" ? <p>Diretor(a): <strong>{props.loc.responsavel}</strong></p> : <p>Responsável: <strong>{props.loc.responsavel}</strong></p>}
                        <p>Descrição dos Serviços Prestados: <strong>{props.loc.descricao}</strong></p>
                    </Card.Body>
                </Card>
            </Col>
        </Fragment >)
}

export default Local;